import request from '@/utils/request';

export function getInvoiceRecords(params) {
  return request({ url: '/admin/invoice_records', method: 'get', params });
}

export function getInvoiceRecord(id) {
  return request({ url: '/admin/invoice_records/' + id, method: 'get' });
}

export function queryInvoiceOrders(data) {
  return request({ url: '/admin/invoice_records/query-orders', method: 'post', data });
}

export function queryInvoiceRealNames(data) {
  return request({ url: '/admin/invoice_records/query-real-names', method: 'post', data });
}

export function createInvoiceRecord(data) {
  return request({ url: '/admin/invoice_records', method: 'post', data });
}

export function reviewInvoiceRecord(id, data) {
  return request({ url: '/admin/invoice_records/' + id + '/review', method: 'post', data });
}

export function registerManualInvoiceResult(data) {
  return request({ url: '/admin/invoice_records/manual-result', method: 'post', data });
}

export function retryInvoiceTask(id) {
  return request({ url: '/admin/invoice_tasks/' + id + '/retry', method: 'post' });
}

export function getManualTransferTasks(data) {
  return request({ url: '/admin/invoice_records/manual-transfer-tasks', method: 'post', data });
}

export function transferInvoiceTaskToManual(id, data, silentError = false) {
  return request({ url: '/admin/invoice_tasks/' + id + '/transfer-to-manual', method: 'post', data, silentError });
}

export function refreshInvoiceTask(id) {
  return request({ url: '/admin/invoice_tasks/' + id + '/refresh', method: 'post' });
}

export function queryInvoiceEmailResult(id) {
  return request({ url: '/admin/invoice_tasks/' + id + '/email-result', method: 'get' });
}

export function uploadInvoiceProof(data) {
  return request({
    url: '/admin/invoice_records/proof-files',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function downloadInvoiceProofTemplate() {
  return request({ url: '/admin/invoice_records/proof-template', method: 'get', responseType: 'blob' });
}

export function downloadInvoiceProof(id) {
  return request({ url: '/admin/invoice_records/proof-files/' + id, method: 'get', responseType: 'blob' });
}

export function attachInvoiceProof(id, data) {
  return request({
    url: '/admin/invoice_records/' + id + '/proof-files', method: 'post', data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteInvoiceProof(id) {
  return request({ url: '/admin/invoice_records/proof-files/' + id, method: 'delete' });
}

export function exportInvoiceRecords(data) {
  return request({ url: '/admin/invoice_records/export', method: 'post', data });
}

export function previewInvoiceRecords(data) {
  return request({ url: '/admin/invoice_records/export-preview', method: 'post', data });
}

export function getInvoiceExportBatches(params) {
  return request({ url: '/admin/invoice_records/export-batches', method: 'get', params });
}

export function getInvoiceExportBatch(id) {
  return request({ url: '/admin/invoice_records/export-batches/' + id, method: 'get' });
}

export function downloadInvoiceExportBatch(id) {
  return request({ url: '/admin/invoice_records/export-batches/' + id + '/download', method: 'get', responseType: 'blob' });
}
